import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    backgroundColor: "var(--app-bg)",
  },
  mainHeading: {
    fontSize: "26px",
    fontWeight: 500,
    [theme.fn.smallerThan("sm")]: {
      fontSize: "18px",
    },
  },

  tabs: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "var(--app-surface)",
    paddingTop: "12px",
    marginBottom: "20px",
    overflowX: "auto",
    "&::-webkit-scrollbar": { display: "none" },
    "& p": {
      fontSize: "14px",
      margin: "0",
      cursor: "pointer",
      flex: 1,
      textAlign: "center",
      padding: "8px 16px",
      color: "var(--app-text-muted)",
      fontWeight: 500,
      borderBottom: "2px solid transparent",
      fontFamily: "Inter",
      whiteSpace: "nowrap",
      [theme.fn.smallerThan("sm")]: {
        fontSize: "12px",
        padding: "8px 10px",
      },
    },
  },
  active: {
    color: "var(--app-text) !important",
    borderBottom: "2px solid var(--app-text) !important",
  },

  bar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "0px",
    [theme.fn.smallerThan("sm")]: {
      flexDirection: "column",
      gap: "10px",
      alignItems: "flex-start",
    },
  },
  left: {
    display: "flex",
    alignItems: "center",
  },
  right: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    "& button": {
      padding: "5px 10px",
      "& img": { width: "24px" },
    },
  },

  iconBar: {
    padding: "5px 10px",
    background: "var(--app-border)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    "& img": { width: "24px", height: "24px" },
  },
  iconBarActive: {
    background: "#fae7be",
  },

  filterRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 30px",
    borderRadius: "10px",
    [theme.fn.smallerThan("md")]: {
      flexDirection: "column",
      padding: "0 10px",
      gap: "10px",
      alignItems: "stretch",
    },
  },
  searchBox: {
    width: "600px",
    [theme.fn.smallerThan("md")]: {
      width: "100%",
    },
  },
  searchBar: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& input": { height: "50px" },
  },
  filterBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "20px",
    [theme.fn.smallerThan("sm")]: {
      justifyContent: "space-between",
      gap: "8px",
    },
  },
  filter: {
    height: "78.77px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    "& input": { height: "50px" },
    "& .mantine-Input-icon": { paddingLeft: "20px" },
    "& .mantine-Input-input": { paddingLeft: "3rem" },
    "& img": { width: "30px", height: "auto" },
    [theme.fn.smallerThan("sm")]: {
      height: "auto",
      width: "100%",
    },
  },
  addMedicationBtn: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid var(--app-primary)",
    backgroundColor: "var(--app-primary)",
    height: 44,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "var(--app-on-primary)",
    ":hover": { backgroundColor: "var(--app-primary)", opacity: 0.8 },
    [theme.fn.smallerThan("sm")]: {
      fontSize: 13,
      padding: "8px 12px",
      height: 38,
    },
  },
}));

export default useStyles;
